export default "__VITE_ASSET__udZRDwXZ__"